import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = ({
  value,
  onChange,
  placeholder = 'Enter password',
  required = false,
  name,
  id,
  autoComplete = 'new-password',
  className = '',
  disabled = false,
  'data-testid': dataTestId,
  ...rest
}) => {
  const [visible, setVisible] = useState(false);

  const baseClasses =
    'appearance-none block w-full px-3 py-2 pr-10 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm';

  return (
    <div className="relative">
      <input
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        name={name}
        id={id}
        autoComplete={autoComplete}
        disabled={disabled}
        className={`${baseClasses} ${className}`}
        {...(dataTestId ? { 'data-testid': dataTestId } : {})}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 pr-3 flex items-center"
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        {...(dataTestId ? { 'data-testid': `${dataTestId}-toggle` } : {})}
      >
        {visible ? (
          <EyeOff className="h-5 w-5 text-gray-400" />
        ) : (
          <Eye className="h-5 w-5 text-gray-400" />
        )}
      </button>
    </div>
  );
};

export default PasswordInput;
